// extracted by mini-css-extract-plugin
module.exports = {"Container":"DashboardFavoritesCards_Container__ONLZD","button":"DashboardFavoritesCards_button__3sck8","Card":"DashboardFavoritesCards_Card__1FlkI"};